import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Select from "components/Select";

const years = _(2013)
  .range(new Date().getFullYear() + 2)
  .reverse()
  .map((value) => ({ value, label: value }))
  .value();

const YearDropdown = ({
  label = "",
  value = { to: undefined, from: undefined },
  range,
  name,
  onChange,
}) => {
  let customRange;
  if (range && range.minYear && range.minYear !== Infinity) {
    customRange = _(range.minYear)
      .range(range.maxYear + 1)
      .reverse()
      .map((value) => ({ value, label: value }))
      .value();
  }
  return (
    <div className="range-datepicker-block">
      {label && <FormattedMessage id={label} tagName="label" />}
      <div className="range-block">
        <Select
          options={!!customRange ? customRange : years}
          selectedOption={value.from}
          onChange={(data) => {
            const { value: fromValue } = data || { value: undefined };
            const isToYearBehind = fromValue! > (value.to || 3000);

            onChange(fromValue, `${name}.from`);
            isToYearBehind && onChange(undefined, `${name}.to`);
            if (!fromValue && !value.to) {
              onChange(undefined, name);
            }
          }}
          placeholder=""
          className="min-width-select-forms text-12"
        />
        <span className="date-label">
          <FormattedMessage id="DATE_LABEL" />
        </span>
        <Select
          options={
            !!customRange
              ? customRange.filter((y) => y.value >= (value.from || 0))
              : years.filter((y) => y.value >= (value.from || 0))
          }
          selectedOption={value.to}
          onChange={(data) => {
            const { value: fromValue } = data || { value: undefined };
            onChange(fromValue, `${name}.to`);
            if (!fromValue && !value.from) {
              onChange(undefined, name);
            }
          }}
          placeholder=""
          className="min-width-select-forms text-12"
        />
      </div>
    </div>
  );
};

export default YearDropdown;
